export default __webpack_public_path__ + "static/media/login-background.f1131e2c.png";